import React from 'react';


const BackgroundManager: React.FC = () => {
  // Always return null as we only support 'flat' background now which has no component
  return null;
};

export default BackgroundManager;
